import React, { ReactPortal } from 'react';
import ReactDom from 'react-dom';
import IPortalRender from './IPortalRender';

const PortalRender: React.FunctionComponent<IPortalRender> = (props) => {
  const portalElement = document.getElementById(props.portalId);

  return (
    <>
      {portalElement && ReactDom.createPortal(props.children, portalElement)}
    </>
  );
};

export default PortalRender;
